var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCsv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21026",
    "data-name": "Grupo 21026",
    transform: "translate(11777 22117)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_2078",
    "data-name": "Rect\\xE1ngulo 2078",
    width: 28,
    height: 28,
    transform: "translate(-11777 -22117)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_27721",
    "data-name": "Trazado 27721",
    d: "M5.19-10.515a4.552,4.552,0,0,1,1.595.244,4.765,4.765,0,0,1,1.32.794l-.794.931a3.18,3.18,0,0,0-2.03-.778A2.569,2.569,0,0,0,3.168-8.317a5.211,5.211,0,0,0-.8,3.236,5.233,5.233,0,0,0,.794,3.2A2.527,2.527,0,0,0,5.267-.853a2.816,2.816,0,0,0,1.175-.229A6.172,6.172,0,0,0,7.51-1.723l.717.916A3.912,3.912,0,0,1,6.976.032,4.321,4.321,0,0,1,5.221.368,4.172,4.172,0,0,1,2.939-.266,4.168,4.168,0,0,1,1.382-2.128,7.115,7.115,0,0,1,.825-5.081,6.871,6.871,0,0,1,1.4-8.035,4.278,4.278,0,0,1,2.977-9.889,4.063,4.063,0,0,1,5.19-10.515Zm7.311,0a4.872,4.872,0,0,1,1.8.3,4.933,4.933,0,0,1,1.45.923l-.794.885A4.519,4.519,0,0,0,13.791-9.1a3.377,3.377,0,0,0-1.229-.221,2.28,2.28,0,0,0-1.358.382,1.283,1.283,0,0,0-.534,1.114,1.5,1.5,0,0,0,.183.771,1.636,1.636,0,0,0,.679.572,8.88,8.88,0,0,0,1.442.549,9.4,9.4,0,0,1,1.648.656,2.858,2.858,0,0,1,1.061.969,2.8,2.8,0,0,1,.4,1.564,2.931,2.931,0,0,1-.45,1.618,3.012,3.012,0,0,1-1.3,1.1,4.693,4.693,0,0,1-2.007.4A4.894,4.894,0,0,1,8.762-.991l.794-.885a5.173,5.173,0,0,0,1.3.786,3.855,3.855,0,0,0,1.465.267A2.622,2.622,0,0,0,13.936-1.3a1.638,1.638,0,0,0,.641-1.4,1.7,1.7,0,0,0-.2-.862,1.768,1.768,0,0,0-.679-.618,6.963,6.963,0,0,0-1.4-.549A6.145,6.145,0,0,1,9.937-5.906a2.4,2.4,0,0,1-.748-1.862,2.49,2.49,0,0,1,.42-1.419,2.793,2.793,0,0,1,1.175-.977A4.03,4.03,0,0,1,12.5-10.515Zm12.287.183L21.43.184H19.873L16.485-10.332h1.557l2.641,8.944,2.641-8.944Z",
    transform: "translate(-11775.825 -22098)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCsv);
export default __webpack_public_path__ + "static/media/icon-csv.e72dffc4e9965fea3e12dc5c10673855.svg";
export { ForwardRef as ReactComponent };